import {
    RequestKeys,
} from 'app/hooks/useRequest'
import request from 'app/requests/ServiceCenter/ServiceCenter.requests'
import ChangeHistory from 'app/shared-components/ChangeHistory'

export default function ServiceCenterChangeHistory({
    id,
}: Readonly<{ id: number }>) {
    return (
        <ChangeHistory
            id={id}
            requestKey={RequestKeys.getServiceCenterModifications}
            config={request.modifications}
            configName="ServiceHistoryChangeHistory"
            name="ServiceHistoryChangeHistory"
            labelPrefixForChangedColumn={['ServiceCenter']}
        />
    )
}
